import { render, staticRenderFns } from "./HomeUcreate.vue?vue&type=template&id=5ae8debe&scoped=true"
import script from "./HomeUcreate.vue?vue&type=script&lang=js"
export * from "./HomeUcreate.vue?vue&type=script&lang=js"
import style0 from "./HomeUcreate.vue?vue&type=style&index=0&id=5ae8debe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8debe",
  null
  
)

export default component.exports